// App
import React from 'react';

// Constellation
import { Box, IconButton, Text } from '@zillow/constellation-10';
import { IconChevronLeftFilled, IconChevronRightFilled } from '@zillow/constellation-icons';

// Misc / utils
import { scrollAlertWindowMobileStyles } from './styles';
import IconPointer from '../images/icons/pointIcon.inline.svg';

const ScrollAlert = () => {
  return (
    <Box css={scrollAlertWindowMobileStyles}>
      <Box css={{ display: 'flex', width: '160px', marginBottom: '400', justifyContent: 'space-between' }}>
        <Box css={{ marginTop: '600' }}>
          <IconButton
            title="Previous"
            icon={<IconChevronLeftFilled />}
            shape="circle"
            emphasis="filled"
            size="sm"
            css={{ color: 'icon.onHero.neutral' }}
          />
        </Box>
        <Box css={{ marginTop: '1000' }}>
          <IconPointer />
        </Box>
        <Box css={{ marginTop: '600' }}>
          <IconButton
            title="Next"
            icon={<IconChevronRightFilled />}
            shape="circle"
            emphasis="filled"
            size="sm"
            css={{ color: 'icon.onHero.neutral' }}
          />
        </Box>
      </Box>
      <Text textStyle="body-bold" color="text.neutral-fixed">
        Scrollable
      </Text>
    </Box>
  );
};

export default ScrollAlert;
